module.exports = __webpack_public_path__ + "img/logo_192.01828ffc.png";